import Route from '@ember/routing/route';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class BrandSignupPendingApprovalRoute extends Route {
  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/brand/signup/step/pending-approval/');
  }
}

export default BrandSignupPendingApprovalRoute;
